import {
  DEFAULT_CONTAINER_CLASSNAME,
  DEFAULT_CONTENT_CLASSNAME,
  DEFAULT_FONT_SIZE,
  DEFAULT_LINE_HEIGHT,
} from '../constant';
import {PartialFrameElements} from '../type/PartialFrameElements.interface';
import {TextViewerCoreOption} from '../type/TextViewerCoreOption.type';
import {getPageTextViewerSizes} from './getPageTextViewerSizes';

/**
 * 페이지넘김 모드의 여러 스타일을 뷰어 설정에 맞게 적용하는 함수
 */
export function applySettingStylesForPageMode({
  frameElements,
  option,
}: {
  frameElements: PartialFrameElements;
  option: TextViewerCoreOption;
}) {
  const {shadowHostElement, settingStyleElement} = frameElements;
  const {
    size: {width, height},
    margin,
    textColor,
    isDark,
    fontFamily,
  } = option;

  shadowHostElement.style.width = `${width}px`;
  shadowHostElement.style.height = `${height}px`;

  const {
    containerWidth,
    containerHeight,
    contentWidth,
    contentHeight,
    columnWidth,
    columnGap,
  } = getPageTextViewerSizes(option);

  /**
   * 리디움을 참고했습니다.
   *
   * 글꼴
   * https://github.com/readium/readium-shared-js/blob/0d275107f553e8ac088b02689965525de4cccb4a/js/helpers.js#L284-L292
   */
  let settingStyle = `
  * {
    ${fontFamily && `font-family: ${fontFamily} !important;`}
  }

  .${DEFAULT_CONTAINER_CLASSNAME} {
    width: ${containerWidth}px;
    height: ${containerHeight}px;
    padding: ${margin}px 0 !important;
    margin: 0 auto !important;
    overflow: hidden;
    font-size: ${DEFAULT_FONT_SIZE}px;
    line-height: ${DEFAULT_LINE_HEIGHT};
    box-sizing: content-box !important;
  }

  .${DEFAULT_CONTENT_CLASSNAME} {
    width: ${contentWidth}px;
    height: ${contentHeight}px;
    position: relative;
    column-gap: ${columnGap}px;
    column-width: ${columnWidth}px;
    column-count: auto;
    column-fill: auto;
    top: 0;
    left: 0;
    ${textColor && `color: ${textColor};`}
    box-sizing: content-box !important;
    margin: 0 !important;
    padding: 0 !important;
    word-break: break-all;
  }
`;

  /**
   * 어두운 테마일 때 폰트 색상은 기본 설정 상속으로, 배경 색상은 투명으로, 보더는 color의 색으로 강제 처리합니다. (iOS와 동일)
   * https://github.kakaocorp.com/kakaopage/ios/blob/develop/KaKaoPage/Classes/Viewer/BookViewer/Epub/Readium/ReadiumCSS-after.css 참고
   */
  if (isDark) {
    settingStyle += `
  * {
    ${textColor && `color: ${textColor} !important;`}
    background-color: transparent !important;
    border-color: currentColor !important;
  }

  svg text {
    fill: currentColor !important;
    stroke: none !important;
  }
`;
  }

  settingStyleElement.innerHTML = settingStyle;
}
